// Callpage-ref: components/ThemeToggle.tsx (adaptacja: nasze tokens, useTheme z ../contexts/ThemeContext)
import { Moon, Sun } from 'lucide-react';

import { useTheme } from '@/contexts/ThemeContext';

export function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      // Wg Figmy „Icon button / moon" (123:24680): OKRĄGŁY 40×40, białe tło, subtelny border
      // #ebebf0, delikatny cień, ikona 20px.
      className="flex h-10 w-10 items-center justify-center rounded-full border border-border-secondary bg-bg-elevated text-text-secondary shadow-[0_1px_1px_rgba(23,23,33,0.06)] transition-colors hover:bg-bg-tertiary hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500"
    >
      {isDark ? <Sun size={20} aria-hidden="true" /> : <Moon size={20} aria-hidden="true" />}
    </button>
  );
}
